import useLazySelector from "common/redux/useLazySelector";
import { loadFcmAccounts } from "./fcmAccounts.actions";
import FcmAccount from "./fcmAccount";

export default function useFcmAccounts(): FcmAccount[]
{
    return useLazySelector(m => m.fcmAccounts, dispatch => loadFcmAccounts()(dispatch),  m => !m.userState.isCustomer, []);
}